// ABOUTME: Names shared across the applications module: the pro-core path, the React Query key, the error code the
// ABOUTME: off state travels under, and the PRO_ATS variant arm that sees the tracker.
export const APPLICATIONS_API_URL = 'talent/applications';

export const USE_APPLICATIONS_QUERY_KEY = 'applications';

/** The code a 404 from pro-core is mapped to: PRO_ATS is off for this talent, or the route is not deployed. */
export const APPLICATIONS_UNAVAILABLE_ERROR_CODE =
  'error.applications.unavailable';

/**
 * The arm of the PRO_ATS variant that sees the tracker. Every other answer from the proxy (control, the flag
 * off, no variant configured, the proxy unreachable) is the control experience: no applications route.
 */
export const ATS_TRACKER_VARIANT = 'tracker';

/**
 * What the other arm is called in the readout. The proxy names no arm for these talents, so the app names one: an
 * event without an arm cannot be compared against anything.
 */
export const ATS_CONTROL_VARIANT = 'control';

/** The React Query key of one application's detail; the list keeps its own. */
export const USE_APPLICATION_QUERY_KEY = 'application';

export const WITHDRAW_APPLICATION_MUTATION_KEY = 'withdrawApplication';

/** PJL: hiding a row from the talent's own list, and changing the week sent with an application. */
export const SET_APPLICATION_HIDDEN_MUTATION_KEY = 'setApplicationHidden';
export const UPDATE_APPLIED_WEEK_MUTATION_KEY = 'updateAppliedWeek';

/** 404 for a refId that is not this talent's own, or that no longer exists. Never a 403: that would confirm it. */
export const APPLICATION_NOT_FOUND_ERROR_CODE = 'error.application.not-found';

/** 409 once an outcome is reached, or when the opening's process has no talent rule into the withdrawn outcome. */
export const APPLICATION_WITHDRAW_NOT_POSSIBLE_ERROR_CODE =
  'error.application.withdraw-not-possible';

/**
 * What a failure pro-core did not name travels under, so the screen always has exactly one message to show for it: a
 * dropped connection or a proxy page arrives without the structured { code, values } body the API otherwise sends.
 */
export const UNNAMED_ERROR_CODE = 'error.unnamed';

/** Session storage: whether the talent opened or collapsed the applications block ('1' / '0'). */
export const APPLICATIONS_BLOCK_OPEN_KEY = 'applications.block.open';
/** Session storage: how many moved-today applications the talent has already seen open in the block. */
export const APPLICATIONS_BLOCK_SEEN_KEY = 'applications.block.seenMoved';
